import { LANGUAGE_ONLY_COUNTRYCODE_LANGUAGE_MAP, type SearchListingsOptions } from '@ev-tech/search-modules-api';

import { mapSearchStateToSearchListingsFilters } from './mapFilterFields';
import { createSerpUrl } from './createSerpUrl';
import { defaultLifestyleCategoryState } from '../hooks/stores/search/slices/lifestyleCategorySlice';
import { type SearchState } from '../hooks/stores/search/SearchStoreProvider';

export const redirectToSerpPage = (state: SearchState, options: Required<SearchListingsOptions>) => {
  const filters = mapSearchStateToSearchListingsFilters({ ...state, ...defaultLifestyleCategoryState });
  const { language, countryCode } = LANGUAGE_ONLY_COUNTRYCODE_LANGUAGE_MAP[options.language];
  const url = createSerpUrl({ filters, options: { ...options, language, countryCode } });
  window.location.href = url.toString();
};
